import styled from "styled-components"
import { FiMinusCircle } from "react-icons/fi"

export const CartItemContainer = styled.div`
  flex-direction: column;
`
export const CartItemWrapper = styled.div`
  margin-bottom: 8px;
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`
export const ImgWrap = styled.div`
  max-width: 60px;
`
export const Img = styled.img`
  width: 100%;
  border-radius: 4px;
`
export const CakeContent = styled.div`
  width: 100%;
  margin-left: 8px;
`
export const CakeTitle = styled.h4`
  color: #202020;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 4px;
`

export const CakeP = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #202020;
  margin-bottom: 8px;
`

export const Icon = styled.div`
  cursor: pointer;
`

export const RemoveIcon = styled(FiMinusCircle)`
  color: #202020;
  width: 20px;
  height: 20px;
  position: relative;
`
